import { dynamic } from '#/utils/dynamic';

export const userProfileModalComponentByType = {
  UNFOLLOW: dynamic(
    () =>
      import('./Unfollow/UnfollowModalContainer').then((module) => ({
        default: module.UnfollowModalContainer,
      })),
    { strategy: 'always' },
  ),
  CREATE_USER_PROFILE: dynamic(
    () =>
      import('./CreateProfile/CreateProfileModalContainer').then((module) => ({
        default: module.CreateProfileModalContainer,
      })),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
